export enum CMAStatus {
  REQUESTED = "requested",
  DRAFT = "draft",
  ACTIVE = "active",
}
